import { coreApp } from "../../App/CoreApp"
import { CoreApiRequestMethod, CoreBaseApi, CoreBaseApiBasicResult, CoreBaseApiResult } from "../CoreBaseApi";
import { CoreBaseApiEndpoint } from "../CoreBaseApiEndpoint";

export class CoreBaseApiStoreEndpoint extends CoreBaseApiEndpoint {
    public saveData(key: string, value: string): Promise<CoreBaseApiBasicResult> {
        return this.api.sendBasicRequest(`api/Store/SaveData`, CoreApiRequestMethod.POST, {
            simKey: coreApp.simKey,
            dataKey: key,
            value: value
        }, null, () => {
            localStorage.setItem(key, value);
        });
    }

    public deleteData(): Promise<CoreBaseApiBasicResult> {
        return this.api.sendBasicRequest(`api/Store/DeleteData?simKey=${coreApp.simKey}`, CoreApiRequestMethod.DELETE, null, null, () => {
            localStorage.removeItem('saved-game-bs');
        });
    }

    public getData(key: string): Promise<CoreBaseApiResult<string>> {
        return this.api.sendRequest(`api/Store/GetData?simKey=${coreApp.simKey}&dataKey=${coreApp.simKey}`, CoreApiRequestMethod.GET, null, null, localStorage.getItem(key), () => {});
    }

    constructor(api: CoreBaseApi) {
        super(api)
    }
}